import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Portal } from 'src/app/models/entities/portal';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { PortalService } from 'src/app/services/portal.service';

@Component({
  selector: 'app-portal-update',
  templateUrl: './portal-update.component.html',
  styleUrls: ['./portal-update.component.css']
})
export class PortalUpdateComponent implements OnInit {

  destroy$ = new Subject<void>();
  form: FormGroup;
  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private portalService: PortalService,
    private userService: NbsUserService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getPortalById();
  }

  getPortalById() {

    const portalId = parseInt(this.activatedRoute.snapshot.paramMap.get('portalId'));
    this.portalService.getById(portalId).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.form.patchValue(data.data);
    })
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: [],
      portalName: ["", Validators.required],
      portalUrl: [""],
      reportTag1: [""],
      reportTag2: [""],
      reportTag3: [""],
      isActive: true
    })
  }

  update() {
    if (this.form.valid) {
      const portal: Portal = this.form.getRawValue();
      portal.userId = this.userService.getUserId();
      this.portalService.update(portal).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
          this.toastrService.success(data.message, "Başarılı");
          this.router.navigateByUrl('/portal');
        },
        er => {
          this.toastrService.error(er.error.message, "Hata!");
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

}
